import React, { useState, useEffect, useRef } from "react";
import Bugsnag from "@bugsnag/js";
import axios from "axios";
import cookie from "react-cookies";
import CurrencyFormat from "react-currency-format";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ListGroup,
  ListGroupItem,
  Input,
  Label,
} from "reactstrap";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import SEO from "react-seo-component";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import HeroImageRotator from "../../components/common/HeroImageRotator";
import QuoteImageUpload from "../../components/common/QuoteImageUpload";
import constants from "../../Constants";
import util from "../../util";
import "./landing3.css";

const baseURL = constants.baseURL;

// Hero taglines for typing animation
const heroTaglines = [
  ["Move Anything,", "Anywhere", "in South Africa"],
  ["Fast Delivery,", "Fair Prices", "Every Time"],
  ["Book a Truck,", "Track Live", "Get it Done"],
  ["From Small Moves", "to Big Loads", "We've Got You"],
];

const Landing3 = () => {
  const otherOptionsRef = useRef(null);
  
  // Parse URL parameters (same as original)
  const getInitialState = () => {
    let promocode = "";
    let vehicleId = "";
    let truckType = "";
    let justbook = "";
    let deliverylat = "";
    let collectiondate = "";
    let collectiontime = "";
    let description = "";
    let deliverylng = "";
    let collectionlat = "";
    let collectionlng = "";
    let category = "handheld-items";
    let runners = 1;
    let floors = 0;
    let prospectemail = "";
    let prospectmobilenumber = "";
    
    try {
      const queryParams = new URLSearchParams(window.location.search);
      promocode = queryParams.get("promocode") || "";
      truckType = queryParams.get("trucktype") || "";
      justbook = queryParams.get("justbook") || "";
      description = queryParams.get("description") || "";
      deliverylat = queryParams.get("deliverylat") || "";
      deliverylng = queryParams.get("deliverylng") || "";
      collectiondate = queryParams.get("collectiondate") || "";
      collectiontime = queryParams.get("collectiontime") || "";
      collectionlat = queryParams.get("collectionlat") || "";
      collectionlng = queryParams.get("collectionlng") || "";
      category = queryParams.get("category") || "handheld-items";
      runners = queryParams.get("runners") || 1;
      floors = queryParams.get("floors") || 0;
      prospectemail = queryParams.get("prospectemail") || "";
      prospectmobilenumber = queryParams.get("prospectmobilenumber") || "";
      vehicleId = queryParams.get("v") || "";
    } catch (error) {
      Bugsnag.notify(error);
    }
    
    return {
      promocode, vehicleId, truckType, justbook, deliverylat, collectiondate,
      collectiontime, description, deliverylng, collectionlat, collectionlng,
      category, runners: parseInt(runners, 10), floors: parseInt(floors, 10),
      prospectemail, prospectmobilenumber
    };
  };

  const initialState = getInitialState();

  // Helper function to get saved data from localStorage
  const getSavedData = (key, fallback) => {
    try {
      const saved = localStorage.getItem(`l3_${key}`);
      return saved !== null ? saved : fallback;
    } catch (e) {
      return fallback;
    }
  };

  const getSavedNumber = (key, fallback) => {
    try {
      const saved = localStorage.getItem(`l3_${key}`);
      return saved !== null ? parseInt(saved, 10) : fallback;
    } catch (e) {
      return fallback;
    }
  };

  // State management (matching original section.js)
  const [navClass, setNavClass] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openDiscountCode, setOpenDiscountCode] = useState(false);
  const [truckType, setTruckType] = useState(getSavedData("truckType", initialState.truckType));
  const [acceptedOffer, setAcceptedOffer] = useState("");
  const [apierror, setApierror] = useState("");
  const [orderid, setOrderid] = useState("");
  const [collection, setCollection] = useState({
    lat: initialState.collectionlat || getSavedNumber("collectionlat", 0),
    lng: initialState.collectionlng || getSavedNumber("collectionlng", 0),
  });
  const [delivery, setDelivery] = useState({
    lat: initialState.deliverylat || getSavedNumber("deliverylat", 0),
    lng: initialState.deliverylng || getSavedNumber("deliverylng", 0),
  });
  const [collectionAddress, setCollectionAddress] = useState(getSavedData("collectionAddress", ""));
  const [deliveryAddress, setDeliveryAddress] = useState(getSavedData("deliveryAddress", ""));
  const [fullQuote, setFullQuote] = useState({
    tripDistance: 0,
    tripDuration: 0,
    sellingPrice: 0,
    storedQuoteId: "",
    discount: "",
    otherOptions: [],
  });
  const [firstname, setFirstname] = useState(getSavedData("firstname", ""));
  const [lastname, setLastname] = useState(getSavedData("lastname", ""));
  const [email, setEmail] = useState(getSavedData("email", initialState.prospectemail));
  const [mobilenumber, setMobilenumber] = useState(getSavedData("mobilenumber", initialState.prospectmobilenumber));
  const [mobilenumbererror, setMobilenumbererror] = useState(false);
  const [collectiondate, setCollectiondate] = useState(getSavedData("collectiondate", initialState.collectiondate));
  const [collectiontime, setCollectiontime] = useState(getSavedData("collectiontime", initialState.collectiontime));
  const [description, setDescription] = useState(getSavedData("description", initialState.description));
  const [prospectemail, setProspectemail] = useState(getSavedData("prospectemail", initialState.prospectemail));
  const [prospectmobilenumber, setProspectmobilenumber] = useState(getSavedData("prospectmobilenumber", initialState.prospectmobilenumber));
  const [vehicletypes, setVehicletypes] = useState([]);
  const [usercategory] = useState(initialState.category);
  const [promocode, setPromocode] = useState(getSavedData("promocode", initialState.promocode));
  const [runners, setRunners] = useState(getSavedNumber("runners", initialState.runners));
  const [floors, setFloors] = useState(getSavedNumber("floors", initialState.floors));
  const [vehicleProfile, setVehicleProfile] = useState({});
  const [expanded, setExpanded] = useState([]);
  const [highlightedVehicle, setHighlightedVehicle] = useState(null); // For URL param highlight
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [showUserTypePrompt, setShowUserTypePrompt] = useState(false);
  const [userTypeConfirmed, setUserTypeConfirmed] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [showResetSuccess, setShowResetSuccess] = useState(false);
  const [quoteImages, setQuoteImages] = useState([]);
  
  // Generate a unique session ID for this quote attempt
  // This links uploaded images to the eventual quotation
  const [quoteSessionId] = useState(() => {
    // Check if we have an existing session ID in localStorage
    const existingId = localStorage.getItem("l3_quoteSessionId");
    const existingTimestamp = localStorage.getItem("l3_quoteSessionTimestamp");
    
    // Reuse if less than 2 hours old
    if (existingId && existingTimestamp) {
      const age = Date.now() - parseInt(existingTimestamp, 10);
      if (age < 2 * 60 * 60 * 1000) { // 2 hours
        return existingId;
      }
    }
    
    // Generate new session ID: qs_timestamp_randomstring
    const newId = `qs_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
    localStorage.setItem("l3_quoteSessionId", newId);
    localStorage.setItem("l3_quoteSessionTimestamp", Date.now().toString());
    return newId;
  });
  
  // Letter-by-letter animation for hero title
  const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState([]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  // Letter-by-letter typing animation with cycling taglines
  useEffect(() => {
    const currentTagline = heroTaglines[currentTaglineIndex];
    const currentWord = currentTagline[currentWordIndex];
    
    if (isPaused) {
      const pauseTimeout = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
      }, 2500); // Pause to read the complete tagline
      return () => clearTimeout(pauseTimeout);
    }
    
    if (isDeleting) {
      // Delete animation - clear all at once and move to next tagline
      const deleteTimeout = setTimeout(() => {
        setDisplayedText([]);
        setCurrentWordIndex(0);
        setCurrentCharIndex(0);
        setIsDeleting(false);
        setCurrentTaglineIndex((prev) => (prev + 1) % heroTaglines.length);
      }, 300);
      return () => clearTimeout(deleteTimeout);
    }
    
    if (!currentWord) return;
    
    if (currentCharIndex < currentWord.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => {
          const newText = [...prev];
          if (!newText[currentWordIndex]) newText[currentWordIndex] = "";
          newText[currentWordIndex] = currentWord.substring(0, currentCharIndex + 1);
          return newText;
        });
        setCurrentCharIndex(prev => prev + 1);
      }, 50); // Speed of typing
      return () => clearTimeout(timeout);
    } else if (currentWordIndex < currentTagline.length - 1) {
      const timeout = setTimeout(() => {
        setCurrentWordIndex(prev => prev + 1);
        setCurrentCharIndex(0);
      }, 150); // Pause between words
      return () => clearTimeout(timeout);
    } else {
      // Finished typing current tagline, pause before deleting
      setIsPaused(true);
    }
  }, [currentCharIndex, currentWordIndex, currentTaglineIndex, isDeleting, isPaused]);

  // Save user data to localStorage when it changes
  useEffect(() => {
    try {
      if (prospectemail) localStorage.setItem("l3_prospectemail", prospectemail);
      if (prospectmobilenumber) localStorage.setItem("l3_prospectmobilenumber", prospectmobilenumber);
      if (email) localStorage.setItem("l3_email", email);
      if (mobilenumber) localStorage.setItem("l3_mobilenumber", mobilenumber);
      if (firstname) localStorage.setItem("l3_firstname", firstname);
      if (lastname) localStorage.setItem("l3_lastname", lastname);
      if (description) localStorage.setItem("l3_description", description);
      if (collectiondate) localStorage.setItem("l3_collectiondate", collectiondate);
      if (collectiontime) localStorage.setItem("l3_collectiontime", collectiontime);
      if (truckType) localStorage.setItem("l3_truckType", truckType);
      if (promocode) localStorage.setItem("l3_promocode", promocode);
      localStorage.setItem("l3_runners", runners.toString());
      localStorage.setItem("l3_floors", floors.toString());
      // Save addresses
      if (collection.lat) localStorage.setItem("l3_collectionlat", collection.lat.toString());
      if (collection.lng) localStorage.setItem("l3_collectionlng", collection.lng.toString());
      if (delivery.lat) localStorage.setItem("l3_deliverylat", delivery.lat.toString());
      if (delivery.lng) localStorage.setItem("l3_deliverylng", delivery.lng.toString());
      if (collectionAddress) localStorage.setItem("l3_collectionAddress", collectionAddress);
      if (deliveryAddress) localStorage.setItem("l3_deliveryAddress", deliveryAddress);
    } catch (e) {
      // localStorage not available
    }
  }, [prospectemail, prospectmobilenumber, email, mobilenumber, firstname, lastname, description, collectiondate, collectiontime, truckType, promocode, runners, floors, collection, delivery, collectionAddress, deliveryAddress]);

  // Reset all saved data - show confirmation modal
  const resetSavedData = () => {
    setShowResetConfirm(true);
  };

  // Actually perform the reset after user confirms
  const confirmResetData = () => {
    try {
      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("l3_")) {
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));
      // Reset state
      setProspectemail("");
      setProspectmobilenumber("");
      setEmail("");
      setMobilenumber("");
      setFirstname("");
      setLastname("");
      setDescription("");
      setCollectiondate("");
      setCollectiontime("");
      setTruckType("");
      setPromocode("");
      setRunners(0);
      setFloors(0);
      setCollection({ lat: 0, lng: 0 });
      setDelivery({ lat: 0, lng: 0 });
      setCollectionAddress("");
      setDeliveryAddress("");
      setFullQuote({});
      setAgreeToTerms(false);
      setShowResetConfirm(false);
      setShowResetSuccess(true);
      setTimeout(() => {
        setShowResetSuccess(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 2000);
    } catch (e) {
      console.error("Error clearing localStorage:", e);
    }
  };

  // Scroll handling
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = document.documentElement.scrollTop;
      if (currentScroll > 100) {
        setNavClass("nav-sticky");
      } else {
        setNavClass("");
      }
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  // Load vehicle types on mount
  useEffect(() => {
    getVehicleTypes();
    // getVehicleProfile is intentionally not in deps to run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getVehicleProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto-get quote only if key fields came from URL params (fresh navigation, not a return visit)
  useEffect(() => {
    const hasUrlQuoteParams = initialState.collectionlat && initialState.deliverylat && initialState.truckType;
    if (vehicletypes.length > 0 && validStepOne() && hasUrlQuoteParams) {
      getQuote();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicletypes]);

  // Auto-scroll to and expand vehicle if trucktype is in URL params
  useEffect(() => {
    if (vehicletypes.length > 0 && initialState.truckType) {
      const matchingVehicle = vehicletypes.find(
        (v) => v.type?.toLowerCase() === initialState.truckType.toLowerCase()
      );
      if (matchingVehicle) {
        // Expand the matching vehicle card first
        setExpanded([matchingVehicle.type]);
        setHighlightedVehicle(matchingVehicle.type);
        
        // Then scroll to that specific vehicle card
        setTimeout(() => {
          const vehicleElement = document.getElementById(`vehicle-${matchingVehicle.type}`);
          if (vehicleElement) {
            vehicleElement.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            // Fallback to vehicles section
            document.getElementById("vehicles")?.scrollIntoView({ behavior: "smooth" });
          }
        }, 400);
        
        // Clear highlight after 5 seconds
        setTimeout(() => {
          setHighlightedVehicle(null);
        }, 5000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicletypes]);

  const getVehicleProfile = () => {
    const vehicleId = initialState.vehicleId;
    if (vehicleId?.length > 3) {
      axios
        .post(baseURL + "/vehicle-profile", {
          vehicleid: vehicleId,
          source_: util.navigator_() + util.source_() + " qtref:" + document?.referrer,
          quotevehicleid: vehicleProfile.vehicleid,
          ...util.getAllGoogleClickIds(),
        })
        .then((response) => {
          const vp = response.data;
          setVehicleProfile(vp);
          if (vp.trucktype) setTruckType(vp.trucktype);
          if (vp?.idnumber?.length > 0) {
            document.getElementById("pagefragmenttop")?.scrollIntoView();
          }
        });
    }
  };

  const getVehicleTypes = () => {
    axios.get(baseURL + "/vehicle-types").then((response) => {
      const data = response.data;
      setVehicletypes(data?.vehicles || []);
    });
  };

  const validStepOne = () => {
    if (prospectemail.length === 0) return false;
    if (prospectmobilenumber.length === 0) return false;
    if (truckType === "") return false;
    if (!delivery.lat) return false;
    if (!collection.lat) return false;
    return !(collection.lat === delivery.lat && collection.lng === delivery.lng);
  };

  const validStepTwo = () => {
    return !(
      firstname.length === 0 ||
      lastname.length === 0 ||
      email.length === 0 ||
      mobilenumber.length === 0 ||
      collectiondate.length === 0 ||
      collectiontime.length === 0 ||
      description.length === 0
    );
  };

  const getQuote = () => {
    if (!validStepOne()) return;

    // Show driver/customer prompt if not already confirmed
    if (!userTypeConfirmed) {
      setShowUserTypePrompt(true);
      return;
    }

    setLoading(true);
    setApierror("");
    setAcceptedOffer("");
    setFullQuote({
      tripDistance: 0,
      tripDuration: 0,
      sellingPrice: 0,
      storedQuoteId: "",
      discount: "",
      otherOptions: [],
    });

    axios
      .post(baseURL + "/quote", {
        description,
        duration: 0,
        trips: 0,
        truckType: vehicleProfile.trucktype || truckType,
        delivery,
        collection,
        category: usercategory,
        promocode,
        runners,
        floors,
        prospectemail,
        collectiondate,
        collectiontime,
        prospectmobilenumber,
        quoteSessionId, // Links uploaded images to this quote
        source_: util.navigator_() + util.source_() + " qtref:" + document?.referrer,
        quotevehicleid: vehicleProfile.vehicleid,
        ...util.getAllGoogleClickIds(),
      })
      .then((response) => {
        if (response.data.sellingPrice > 0) {
          setLoading(false);
          setFullQuote({
            tripDistance: response.data.tripDistance,
            tripDuration: response.data.tripDuration,
            sellingPrice: response.data.sellingPrice,
            storedQuoteId: response.data.quoteId,
            discount: response.data.discount,
            otherOptions: response.data.otherOptions || [],
          });
          setTimeout(() => {
            document.getElementById("mainquote")?.scrollIntoView({ behavior: "smooth" });
            scrollToCurrentOtherOption();
          }, 100);
        }
      })
      .catch((e) => {
        setLoading(false);
        setApierror("Check your addresses or vehicle type and try again.");
        Bugsnag.notify(e);
      });
  };

  const confirmCustomerAndGetQuote = () => {
    setUserTypeConfirmed(true);
    setShowUserTypePrompt(false);
    // Call getQuote again, now it will proceed since userTypeConfirmed is true
    setTimeout(() => {
      getQuoteInternal();
    }, 100);
  };

  const getQuoteInternal = () => {
    if (!validStepOne()) return;

    setLoading(true);
    setApierror("");
    setAcceptedOffer("");
    setFullQuote({
      tripDistance: 0,
      tripDuration: 0,
      sellingPrice: 0,
      storedQuoteId: "",
      discount: "",
      otherOptions: [],
    });

    axios
      .post(baseURL + "/quote", {
        description,
        duration: 0,
        trips: 0,
        truckType: vehicleProfile.trucktype || truckType,
        delivery,
        collection,
        category: usercategory,
        promocode,
        runners,
        floors,
        prospectemail,
        collectiondate,
        collectiontime,
        prospectmobilenumber,
        quoteSessionId, // Links uploaded images to this quote
        source_: util.navigator_() + util.source_() + " qtref:" + document?.referrer,
        quotevehicleid: vehicleProfile.vehicleid,
        ...util.getAllGoogleClickIds(),
      })
      .then((response) => {
        if (response.data.sellingPrice > 0) {
          setLoading(false);
          setFullQuote({
            tripDistance: response.data.tripDistance,
            tripDuration: response.data.tripDuration,
            sellingPrice: response.data.sellingPrice,
            storedQuoteId: response.data.quoteId,
            discount: response.data.discount,
            otherOptions: response.data.otherOptions || [],
          });
          setTimeout(() => {
            document.getElementById("mainquote")?.scrollIntoView({ behavior: "smooth" });
            scrollToCurrentOtherOption();
          }, 100);
        }
      })
      .catch((e) => {
        setLoading(false);
        setApierror("Check your addresses or vehicle type and try again.");
        Bugsnag.notify(e);
      });
  };

  const acceptQuote = () => {
    setLoading(true);
    setApierror("");

    axios
      .post(baseURL + "/accept-quote", {
        fullQuote,
        firstname,
        lastname,
        email,
        mobilenumber,
        collectiondate,
        collectiontime,
        description,
        acceptedOffer: acceptedOffer?.toLowerCase(),
      })
      .then((response) => {
        setLoading(false);
        setSuccess(response.status === 200);
        setOpenSuccessModal(true);
        setOrderid(response?.data?.orderid);
        
        if (response.status === 200 && response?.data?.orderid?.length > 0) {
          cookie.save(
            "currentOrder",
            `email=${email}&orderid=${response.data.orderid}`,
            { path: "/", maxAge: 86400, secure: true }
          );
        }
      })
      .catch((e) => {
        setLoading(false);
        setApierror("Request failed. Please try again.");
      });
  };

  const scrollToCurrentOtherOption = () => {
    try {
      if (!fullQuote.otherOptions || fullQuote.otherOptions.length === 0) return;
      if (!otherOptionsRef.current) return;

      const container = otherOptionsRef.current;
      const index = fullQuote.otherOptions.findIndex(
        (option) => option.truckType === truckType
      );
      if (index === -1) return;

      const children = container.children || [];
      if (index >= children.length) return;

      const target = children[index];
      if (typeof target?.scrollIntoView === "function") {
        target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const vehiclePriceTip = (vehicle, change) => {
    const roundToNearestFifty = (num) => Math.round(num / 50) * 50;
    let costOfDelivery =
      2000 * (vehicle?.pricePerMeterCents || 0) +
      1200 * (vehicle?.pricePerSecondCents || 0) +
      (vehicle?.handlingFeeCents || 0);
    let serviceFeePercentage = (vehicle?.serviceFeePercentage || 0) * costOfDelivery;
    return roundToNearestFifty(
      Math.round(((costOfDelivery + serviceFeePercentage) * 1.15 * (change || 1)) / 100)
    );
  };

  const getImage = (trucktype) => {
    try {
      return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
    } catch (error) {
      return "";
    }
  };

  const changeTruck = () => {
    setTruckType("");
    setFullQuote({
      tripDistance: 0,
      tripDuration: 0,
      sellingPrice: 0,
      storedQuoteId: "",
      discount: "",
      otherOptions: [],
    });
    setTimeout(() => {
      document.getElementById("vehiclelist")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const expandVehicleView = (type) => {
    let arr = [...expanded];
    let index = arr.indexOf(type);
    if (index > -1) {
      arr.splice(index, 1);
    } else {
      arr.push(type);
    }
    setExpanded(arr);
  };

  const navItems = [
    { id: 1, idnm: "home", navheading: "Home" },
    { id: 2, idnm: "vehicles", navheading: "Vehicles" },
    { id: 3, idnm: "pricing", navheading: "Get Quote" },
  ];

  return (
    <React.Fragment>
      <SEO
        title="On-demand Truck & Driver Hire | Instant Quotes"
        titleTemplate="QikTruck"
        titleSeparator=" - "
        description="Move your goods with verified drivers and trucks. Get instant quotes, transparent pricing, and real-time tracking."
        image="https://media.qiktruck.co.za/qiktruck-preview-header.png"
        pathname="https://qiktruck.co.za"
        twitterUsername="qiktrucksa"
      />

      <NavbarPage navItems={navItems} navClass={navClass} imglight={false} />

      {/* Success Modal */}
      <Modal isOpen={success && openSuccessModal}>
        <ModalHeader>
          <i className="mdi mdi-check orange-circle order-received"></i>
          Order Received
        </ModalHeader>
        <ModalBody>
          <ListGroup className="black-text">
            <ListGroupItem>
              <i className="mdi mdi-check orange-circle order-received-list"></i>
              A driver will be in touch shortly to confirm your order.
            </ListGroupItem>
            <ListGroupItem>
              <i className="mdi mdi-email order-received-list"></i>
              You will receive an email with your invoice shortly.
            </ListGroupItem>
            <ListGroupItem>
              <i className="mdi mdi-cash-multiple order-received-list"></i>
              You can pay now or after the delivery.
            </ListGroupItem>
            <ListGroupItem>
              <i className="mdi mdi-account-alert order-received-list"></i>
              Produce your ID when the driver arrives.
            </ListGroupItem>
            <ListGroupItem>
              <i className="mdi mdi-check orange-circle order-received-list"></i>
              Happy moving!
            </ListGroupItem>
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setOpenSuccessModal(false);
              window.location.href = "/track-order?paynow=yes&orderid=" + orderid + "&email=" + email;
            }}
          >
            Okay
          </Button>
        </ModalFooter>
      </Modal>

      {/* Options Modal */}
      <Modal isOpen={openDiscountCode}>
        <ModalHeader>
          <i className="mdi mdi-clipboard-text order-received"></i>
          More options
        </ModalHeader>
        <ModalBody>
          <Label>Add Helpers</Label>
          <br />
          <span>How many people do you need to carry and load the goods?</span>
          <Input
            type="number"
            defaultValue={runners}
            min={0}
            onChange={(e) => setRunners(parseInt(e.target.value, 10))}
          />
          <br /><br />
          <Label>Add Floors</Label>
          <br />
          <span>How many floors are we required to carry the goods?</span>
          <Input
            type="number"
            min={0}
            defaultValue={floors}
            onChange={(e) => setFloors(parseInt(e.target.value, 10))}
          />
          <br /><br />
          <Label>Discount code</Label>
          <br />
          <span>Lucky one! Our Discount codes are up to 30% off!</span>
          <Input
            type="text"
            defaultValue={promocode}
            placeholder="Type your discount code here"
            onChange={(e) => setPromocode(e.target.value.toUpperCase())}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setOpenDiscountCode(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              getQuote();
              setOpenDiscountCode(false);
            }}
          >
            Apply
          </Button>
        </ModalFooter>
      </Modal>

      <main className="landing3-main">
        <div id="pagefragmenttop"></div>
        
        {/* Hero Section */}
        <section className="l3-hero" id="home">
          <div className="l3-hero-content">
            <div className="l3-hero-text">
              <div className="l3-hero-badge">
                <span className="l3-hero-badge-dot"></span>
                <span>Drivers Ready Near You</span>
              </div>
              
              <h1 className="l3-hero-title">
                <span className="l3-typing-text">
                  {displayedText[0] || ""}
                </span>{" "}
                <span className="l3-hero-title-accent l3-typing-text">
                  {displayedText[1] || ""}
                </span>
                <br />
                <span className="l3-typing-text">
                  {displayedText[2] || ""}
                </span>
                <span className={`l3-typing-cursor ${isDeleting ? 'l3-typing-cursor-fast' : ''}`}>|</span>
              </h1>
              
              <p className="l3-hero-subtitle">
                Get instant quotes from verified drivers. Transparent pricing, 
                real-time tracking, and safe delivery : every time.
              </p>
              
              <div className="l3-hero-stats">
                <div className="l3-hero-stat">
                  <div className="l3-hero-stat-value">1M+</div>
                  <div className="l3-hero-stat-label">Deliveries Completed</div>
                </div>
                <div className="l3-hero-stat">
                  <div className="l3-hero-stat-value"> 15,000+</div>
                  <div className="l3-hero-stat-label">Verified Drivers</div>
                </div>
                <div className="l3-hero-stat">
                  <div className="l3-hero-stat-value">4.8★</div>
                  <div className="l3-hero-stat-label">Customer Rating</div>
                </div>
              </div>
              
              {/* App Download Section */}
              <div className="l3-hero-app-download">
                <a 
                  href="https://apps.apple.com/za/app/qiktruck-customer/id6502938538" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="l3-app-store-btn"
                >
                  <img 
                    src="/app-store-badge.svg" 
                    alt="Download on the App Store" 
                  />
                </a>
                <a 
                  href="https://play.google.com/store/apps/details?id=com.qiktruck.customer" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="l3-google-play-btn"
                >
                  <img 
                    src="/google-play-badge.png" 
                    alt="Get it on Google Play" 
                  />
                </a>
                <button 
                  className="l3-get-quote-btn"
                  onClick={() => document.getElementById("l3-hero-form")?.scrollIntoView({ behavior: "smooth" })}
                >
                  Get a Quote
                </button>
              </div>
            </div>
            
            {/* Mobile Hero Image - Only visible on mobile */}
            <div className="l3-mobile-hero-image">
              <HeroImageRotator className="l3-mobile-hero-img" />
            </div>

            {/* Quick Quote Form in Hero */}
            <div className="l3-hero-form" id="l3-hero-form">
              <h2 className="l3-hero-form-title">Get Your Free Quote</h2>
              <p className="l3-hero-form-subtitle">Instant pricing with no hidden fees</p>
              
              <div className="l3-form-group">
                <label className="l3-form-label">Email Address *</label>
                <input
                  type="email"
                  className="l3-form-input"
                  placeholder="your@email.com"
                  defaultValue={prospectemail}
                  onChange={(e) => {
                    setProspectemail(e.target.value);
                    setEmail(e.target.value);
                  }}
                />
              </div>
              
              <div className="l3-form-group">
                <label className="l3-form-label">Mobile Number *</label>
                <input
                  type="tel"
                  className="l3-form-input"
                  placeholder="0821234567"
                  minLength={10}
                  defaultValue={prospectmobilenumber}
                  onChange={(e) => {
                    setProspectmobilenumber(e.target.value);
                    setMobilenumber(e.target.value);
                    setMobilenumbererror(
                      e.target.value.length < 10 || /^\d+$/.exec(e.target.value) === null
                    );
                  }}
                />
                {mobilenumbererror && (
                  <p className="l3-form-error">Valid mobile number is required</p>
                )}
              </div>
              
              <a href="#vehiclelist" className="l3-btn l3-btn-primary">
                Select Vehicle & Get Quote
                <i className="mdi mdi-arrow-down"></i>
              </a>
              
              <p style={{ textAlign: "center", marginTop: "16px", fontSize: "13px", color: "#6c757d" }}>
                <i className="mdi mdi-shield-check" style={{ color: "#34d1bf", marginRight: "6px" }}></i>
                No payment required • Free cancellation
              </p>
            </div>
          </div>
        </section>

        {/* Trust Badges */}
        <section className="l3-trust">
          <div className="l3-trust-container">
            <div className="l3-trust-header">
              <p className="l3-trust-label">Trusted by thousands of customers across South Africa</p>
            </div>
            <div className="l3-trust-grid">
              {[
                { icon: "mdi mdi-shield-check", title: "Verified Drivers", desc: "Background-checked & licensed" },
                { icon: "mdi mdi-clock-fast", title: "Same Day Delivery", desc: "Book now, move today" },
                { icon: "mdi mdi-cash-multiple", title: "Transparent Pricing", desc: "No hidden fees ever" },
                { icon: "mdi mdi-map-marker-path", title: "Real-time Tracking", desc: "Track your delivery live" },
              ].map((item, idx) => (
                <div key={idx} className="l3-trust-item">
                  <div className="l3-trust-icon"><i className={item.icon}></i></div>
                  <div className="l3-trust-text">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Vehicle Selection Section */}
        <section className="l3-vehicles" id="vehicles">
          <div className="l3-section-container">
            <div className="l3-section-header">
              <span className="l3-section-badge">Step 1</span>
              <h2 className="l3-section-title">Choose Your Vehicle and Driver</h2>
              <p className="l3-section-subtitle">
                Select from our range of vehicles. All come with a professional driver.
              </p>
            </div>
            
            <div id="vehiclelist"></div>
            
            <div className="l3-vehicle-grid">
              {vehicletypes
                ?.filter((v) => v.sell === true)
                ?.map((vehicle, index) => {
                  const isExpanded = expanded.indexOf(vehicle.type) !== -1;
                  const isSelected = truckType === vehicle.type;
                  
                  return (
                    <div
                      key={vehicle.type}
                      id={`vehicle-${vehicle.type}`}
                      className={`l3-vehicle-card ${isSelected ? "selected" : ""} ${isExpanded ? "expanded" : ""} ${highlightedVehicle === vehicle.type ? "highlighted" : ""}`}
                      onClick={() => !isExpanded && expandVehicleView(vehicle.type)}
                    >
                      {!isExpanded ? (
                        <>
                          <div className="l3-vehicle-image">
                            <img src={getImage(vehicle.type)} alt={vehicle.bodylabel} />
                            {index === 0 && <span className="l3-vehicle-badge">Popular</span>}
                          </div>
                          <div className="l3-vehicle-content">
                            <span className="l3-vehicle-loadgroup">{vehicle.loadgroup}</span>
                            <h3 className="l3-vehicle-name">{vehicle.tip?.shortform}</h3>
                            <p className="l3-vehicle-examples">{vehicle.tip?.examples}</p>
                            <div className="l3-vehicle-price">
                              <span className="l3-vehicle-price-from">From</span>
                              <span className="l3-vehicle-price-value">
                                R{vehiclePriceTip(vehicle, 1)}
                              </span>
                              {vehiclePriceTip(vehicle, 1.13) !== vehiclePriceTip(vehicle, 1) && (
                                <span className="l3-vehicle-price-old">
                                  R{vehiclePriceTip(vehicle, 1.13)}
                                </span>
                              )}
                            </div>
                          </div>
                          <span className="l3-vehicle-cta">Select body type →</span>
                        </>
                      ) : (
                        <div className="l3-vehicle-expanded">
                          <div className="l3-vehicle-expanded-header">
                            <img src={getImage(vehicle.type)} alt={vehicle.bodylabel} />
                            <button 
                              className="l3-vehicle-close"
                              onClick={(e) => { e.stopPropagation(); expandVehicleView(vehicle.type); }}
                            >
                              <i className="mdi mdi-close"></i>
                            </button>
                          </div>
                          <h3>{vehicle.loadgroup}</h3>
                          <p className="l3-vehicle-longform">{vehicle.tip?.longform}</p>
                          <p className="l3-vehicle-benefits">
                            <i className="mdi mdi-star" style={{ color: "#f5861f" }}></i>
                            {vehicle.tip?.benefits}
                          </p>
                          <p className="l3-vehicle-select-prompt">Select a body type:</p>
                          <div className="l3-body-options">
                            {vehicletypes
                              ?.filter((v) => v.loadgroup === vehicle.loadgroup)
                              .map((m) => (
                                <button
                                  key={m.type}
                                  className={`l3-body-option ${truckType === m.type ? "selected" : ""}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTruckType(m.type);
                                    setTimeout(() => {
                                      getQuote();
                                      document.getElementById("addresses")?.scrollIntoView({ behavior: "smooth" });
                                    }, 100);
                                  }}
                                >
                                  <img src={getImage(m.type)} alt={m.bodylabel} />
                                  <span>{m.bodylabel}</span>
                                </button>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </section>

        {/* Address & Details Section */}
        <section className="l3-quote" id="pricing">
          <div className="l3-quote-content">
            <div className="l3-section-header">
              <span className="l3-section-badge" style={{ background: "rgba(255,255,255,0.2)", color: "#fff" }}>
                Step 2
              </span>
              <h2 className="l3-section-title">Enter Your Details</h2>
              <p className="l3-section-subtitle">
                Tell us where to pick up and deliver your goods
              </p>
            </div>

            <div className="l3-quote-form" id="addresses">
              <div className="l3-quote-form-grid">
                <div className="l3-form-group">
                  <label className="l3-form-label">Pick-up Address *</label>
                  <PlacesAutocomplete
                    type="text"
                    className="l3-form-input"
                    placeholder="Where should we collect?"
                    defaultValue={collectionAddress}
                    onPlaceSelected={(place) => {
                      if (!place?.geometry?.location?.lat()) {
                        Bugsnag.notify(new Error("COLLECTION place not found: " + truckType));
                      }
                      setCollection({
                        lat: place?.geometry?.location?.lat(),
                        lng: place?.geometry?.location?.lng(),
                      });
                      setCollectionAddress(place?.formatted_address || "");
                    }}
                  />
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Delivery Address *</label>
                  <PlacesAutocomplete
                    type="text"
                    className="l3-form-input"
                    placeholder="Where should we deliver?"
                    defaultValue={deliveryAddress}
                    onPlaceSelected={(place) => {
                      if (!place?.geometry?.location?.lat()) {
                        Bugsnag.notify(new Error("DELIVERY place not found: " + truckType));
                      }
                      setDelivery({
                        lat: place?.geometry?.location?.lat(),
                        lng: place?.geometry?.location?.lng(),
                      });
                      setDeliveryAddress(place?.formatted_address || "");
                    }}
                  />
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Selected Vehicle</label>
                  <div className="l3-selected-vehicle" onClick={changeTruck}>
                    {truckType ? (
                      <>
                        <img src={getImage(truckType)} alt={truckType} />
                        <span>{truckType.replace("open", " Open").replace("closed", " Closed")}</span>
                        <span className="l3-change-link">Change →</span>
                      </>
                    ) : (
                      <span className="l3-no-vehicle">No vehicle selected - <a href="#vehiclelist">Select one →</a></span>
                    )}
                  </div>
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Options</label>
                  <div className="l3-options-row" onClick={() => setOpenDiscountCode(true)}>
                    <div className="l3-option-item">
                      <i className="mdi mdi-stairs"></i>
                      <span>{floors} Floor{floors === 1 ? "" : "s"}</span>
                    </div>
                    <div className="l3-option-item">
                      <i className="mdi mdi-account-multiple"></i>
                      <span>{runners} Helper{runners === 1 ? "" : "s"}</span>
                    </div>
                    <div className="l3-option-item">
                      <i className="mdi mdi-tag"></i>
                      <span>{promocode || "Discount"}</span>
                    </div>
                  </div>
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Email *</label>
                  <input
                    type="email"
                    className="l3-form-input"
                    placeholder="your@email.com"
                    value={prospectemail}
                    onChange={(e) => {
                      setProspectemail(e.target.value);
                      setEmail(e.target.value);
                    }}
                  />
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Mobile Number *</label>
                  <input
                    type="tel"
                    className="l3-form-input"
                    placeholder="0821234567"
                    value={prospectmobilenumber}
                    onChange={(e) => {
                      setProspectmobilenumber(e.target.value);
                      setMobilenumber(e.target.value);
                      setMobilenumbererror(e.target.value.length < 10 || !/^\d+$/.test(e.target.value));
                    }}
                  />
                  {mobilenumbererror && <p className="l3-form-error">Valid mobile number required</p>}
                </div>

                <div className="l3-form-group full-width">
                  <label className="l3-form-label">What are we moving? *</label>
                  <textarea
                    className="l3-form-input l3-textarea"
                    placeholder="Describe everything you're moving - names, sizes, quantities..."
                    value={description}
                    numberOfLines={5}
                    rows={5}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>

                {/* Image Upload Section */}
                <div className="l3-form-group full-width">
                  <QuoteImageUpload
                    quoteId={fullQuote.storedQuoteId}
                    quoteSessionId={quoteSessionId}
                    images={quoteImages}
                    onImagesChange={setQuoteImages}
                    prospectEmail={prospectemail}
                    prospectMobile={prospectmobilenumber}
                  />
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Collection Date</label>
                  <input
                    type="date"
                    className="l3-form-input"
                    value={collectiondate}
                    min={new Date().toISOString().split("T")[0]}
                    onChange={(e) => setCollectiondate(e.target.value)}
                  />
                </div>

                <div className="l3-form-group">
                  <label className="l3-form-label">Collection Time</label>
                  <input
                    type="time"
                    className="l3-form-input"
                    value={collectiontime}
                    onChange={(e) => setCollectiontime(e.target.value)}
                  />
                </div>
              </div>

              {/* Terms and Conditions Card - Quote Section */}
              <div className="l3-form-group full-width" style={{ marginTop: "24px" }}>
                <div 
                  className={`l3-terms-card ${agreeToTerms ? 'l3-terms-agreed' : ''}`}
                  onClick={() => setAgreeToTerms(!agreeToTerms)}
                >
                  <div className="l3-terms-checkbox">
                    {agreeToTerms && <i className="mdi mdi-check"></i>}
                  </div>
                  <div className="l3-terms-content">
                    <div className="l3-terms-title">
                      I accept the Terms and Conditions
                    </div>
                    <div className="l3-terms-subtitle">
                      I agree to the{" "}
                      <a 
                        href="/terms" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Terms and Conditions
                      </a>
                      {" "}and the limits of liability.
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    checked={agreeToTerms}
                    onChange={() => {}}
                    style={{ display: 'none' }}
                  />
                </div>
                
                {!agreeToTerms && (
                  <p className="l3-terms-warning">
                    <i className="mdi mdi-information-outline"></i>
                    Please accept the Terms and Conditions to continue
                  </p>
                )}
              </div>

              <div style={{ marginTop: "24px" }}>
                <button
                  className="l3-btn l3-btn-primary"
                  onClick={getQuote}
                  disabled={!validStepOne() || loading || !agreeToTerms}
                  style={{ width: "100%" }}
                >
                  {loading ? (
                    <>
                      <span className="l3-spinner"></span>
                      Getting Quote...
                    </>
                  ) : (
                    <>
                      GET QUOTATIONS
                      <i className="mdi mdi-arrow-down"></i>
                    </>
                  )}
                </button>
              </div>

              {/* Validation Errors List */}
              {(!validStepOne() || !agreeToTerms) && !loading && (
                <div className="l3-validation-errors">
                  <p className="l3-validation-title">
                    <i className="mdi mdi-alert-circle-outline"></i>
                    Please complete the following:
                  </p>
                  <ul className="l3-validation-list">
                    {!collection.lat && <li>Pick-up address is required</li>}
                    {!delivery.lat && <li>Delivery address is required</li>}
                    {(collection.lat && delivery.lat && collection.lat === delivery.lat && collection.lng === delivery.lng )? (
                      <li>Pick-up and delivery addresses must be different</li> ): 
                      null
                    }
                    {truckType === "" && <li>Please select a vehicle</li>}
                    {prospectemail.length === 0 && <li>Email address is required</li>}
                    {prospectmobilenumber.length === 0 && <li>Mobile number is required</li>}
                    {mobilenumbererror && prospectmobilenumber.length > 0 && <li>Please enter a valid mobile number</li>}
                    {!agreeToTerms && <li>Please accept the Terms and Conditions</li>}
                  </ul>
                </div>
              )}

              {!loading && apierror && (
                <div className="l3-error-message">
                  <i className="mdi mdi-alert-circle"></i>
                  {apierror}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Quote Result Section */}
        {fullQuote.sellingPrice > 0 && (
          <section className="l3-quote-result-section" id="mainquote">
            <div className="l3-section-container">
              <div className="l3-quote-result-card" id="quote-result-card">
                <div className="l3-quote-result-header">
                  <h3>Your Quote</h3>
                  {fullQuote.storedQuoteId && (
                    <span className="l3-quote-id-badge">
                      Quote ID: {fullQuote.storedQuoteId.split("-")[0]}
                    </span>
                  )}
                  <p>
                    {Math.round(fullQuote.tripDistance / 1000)} km • 
                    ~{Math.round(fullQuote.tripDuration / 60)} min drive
                  </p>
                </div>

                {/* Large Vehicle Image */}
                <div className="l3-quote-vehicle-image">
                  <img src={getImage(truckType)} alt={truckType} />
                </div>
                
                {/* Quote Summary Details */}
                <div className="l3-quote-summary">
                  <div className="l3-quote-summary-row">
                    <span className="l3-quote-summary-label">
                      <i className="mdi mdi-truck"></i> Vehicle
                    </span>
                    <span className="l3-quote-summary-value">
                      {truckType?.replace("open", " (Open)")?.replace("closed", " (Closed)")}
                    </span>
                  </div>
                  <div className="l3-quote-summary-row">
                    <span className="l3-quote-summary-label">
                      <i className="mdi mdi-map-marker"></i> Pick-up
                    </span>
                    <span className="l3-quote-summary-value l3-quote-summary-address">
                      {collectionAddress || "Address selected"}
                    </span>
                  </div>
                  <div className="l3-quote-summary-row">
                    <span className="l3-quote-summary-label">
                      <i className="mdi mdi-map-marker-check"></i> Delivery
                    </span>
                    <span className="l3-quote-summary-value l3-quote-summary-address">
                      {deliveryAddress || "Address selected"}
                    </span>
                  </div>
                  <div className="l3-quote-summary-row">
                    <span className="l3-quote-summary-label">
                      <i className="mdi mdi-calendar"></i> Date & Time
                    </span>
                    <span className="l3-quote-summary-value">
                      {collectiondate} at {collectiontime}
                    </span>
                  </div>
                  <div className="l3-quote-summary-row">
                    <span className="l3-quote-summary-label">
                      <i className="mdi mdi-road-variant"></i> Distance
                    </span>
                    <span className="l3-quote-summary-value">
                      {Math.round(fullQuote.tripDistance / 1000)} km (~{Math.round(fullQuote.tripDuration / 60)} min)
                    </span>
                  </div>
                  {runners > 0 && (
                    <div className="l3-quote-summary-row">
                      <span className="l3-quote-summary-label">
                        <i className="mdi mdi-account-multiple"></i> Runners
                      </span>
                      <span className="l3-quote-summary-value">{runners}</span>
                    </div>
                  )}
                  {floors > 0 && (
                    <div className="l3-quote-summary-row">
                      <span className="l3-quote-summary-label">
                        <i className="mdi mdi-stairs"></i> Floors
                      </span>
                      <span className="l3-quote-summary-value">{floors}</span>
                    </div>
                  )}
                  {description && (
                    <div className="l3-quote-summary-row l3-quote-summary-description">
                      <span className="l3-quote-summary-label">
                        <i className="mdi mdi-package-variant"></i> Items
                      </span>
                      <span className="l3-quote-summary-value">{description}</span>
                    </div>
                  )}
                </div>
                
                <div className="l3-quote-price-display">
                  {fullQuote.discount ? (
                    <span className="l3-discount-badge">
                      {fullQuote.discount} Applied!
                    </span>) : null
                  }
                  <div className="l3-quote-main-price">
                    <CurrencyFormat
                      value={fullQuote.sellingPrice / 100}
                      displayType="text"
                      thousandSeparator={true}
                      prefix="R"
                      decimalScale={0}
                    />
                  </div>
                  <p className="l3-quote-price-note">Including VAT • No hidden fees</p>
                </div>

                {/* Terms and Conditions - Quote Accept */}
                <div className="l3-form-group full-width" style={{ marginBottom: "16px" }}>
                  <div 
                    className={`l3-terms-card ${agreeToTerms ? 'l3-terms-agreed' : ''}`}
                    onClick={() => setAgreeToTerms(!agreeToTerms)}
                  >
                    <div className="l3-terms-checkbox">
                      {agreeToTerms && <i className="mdi mdi-check"></i>}
                    </div>
                    <div className="l3-terms-content">
                      <div className="l3-terms-title">
                        I accept the Terms and Conditions
                      </div>
                      <div className="l3-terms-subtitle">
                        I agree to the{" "}
                        <a 
                          href="/terms" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Terms and Conditions
                        </a>
                        {" "}and the limits of liability.
                      </div>
                    </div>
                    <input
                      type="checkbox"
                      checked={agreeToTerms}
                      onChange={() => {}}
                      style={{ display: 'none' }}
                    />
                  </div>
                  
                  {!agreeToTerms && (
                    <p className="l3-terms-warning">
                      <i className="mdi mdi-information-outline"></i>
                      Please accept the Terms and Conditions to continue
                    </p>
                  )}
                </div>

                <div className="l3-quote-actions">
                  <button
                    className="l3-btn l3-btn-primary l3-btn-accept"
                    disabled={!agreeToTerms}
                    onClick={() => {
                      setAcceptedOffer("sellingPrice");
                      setTimeout(() => {
                        document.getElementById("makebooking")?.scrollIntoView({ behavior: "smooth" });
                      }, 100);
                    }}
                  >
                    Accept Quote & Book
                    <i className="mdi mdi-arrow-right"></i>
                  </button>

                  <button
                    className="l3-btn l3-btn-outline l3-btn-download-pdf"
                    onClick={() => {
                      const totalCents = fullQuote.sellingPrice;
                      const totalRands = totalCents / 100;
                      const exclVat = totalRands / 1.15;
                      const vatAmount = totalRands - exclVat;
                      const serviceFee = exclVat * 0.2;
                      const tripCost = exclVat - serviceFee;
                      const quoteDate = new Date();
                      const validUntil = new Date(quoteDate);
                      validUntil.setDate(validUntil.getDate() + 7);
                      const fmt = (d) => d.toLocaleDateString("en-ZA", { year: "numeric", month: "short", day: "2-digit" });
                      const fmtR = (v) => "R " + v.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                      const vehLabel = truckType?.replace("open", " (Open)")?.replace("closed", " (Closed)") || "";

                      const printWindow = window.open("", "_blank");
                      printWindow.document.write(`
                        <html>
                          <head>
                            <title>QikTruck Quotation${fullQuote.storedQuoteId ? " - " + fullQuote.storedQuoteId.split("-")[0] : ""}</title>
                            <style>
                              * { margin: 0; padding: 0; box-sizing: border-box; }
                              body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; padding: 48px; color: #333; font-size: 14px; line-height: 1.5; }
                              .page { max-width: 720px; margin: 0 auto; }

                              /* Header */
                              .doc-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; }
                              .doc-header h1 { font-size: 22px; font-weight: 700; color: #333; margin-bottom: 2px; }
                              .doc-header .logo { height: 48px; }

                              /* Company info */
                              .doc-title { font-size: 18px; font-weight: 700; color: #333; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
                              .company-info { color: #555; font-size: 13px; line-height: 1.7; margin-bottom: 28px; }

                              /* Bill To + Quote meta */
                              .bill-row { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; }
                              .bill-to h3 { font-size: 13px; font-weight: 700; color: #333; margin-bottom: 6px; }
                              .bill-to p { color: #555; font-size: 13px; }
                              .quote-meta { text-align: right; font-size: 13px; color: #555; }
                              .quote-meta strong { color: #F5861F; }

                              /* Main table */
                              .quote-table { width: 100%; border-collapse: collapse; margin-bottom: 4px; border: 2px solid #4f6367; }
                              .quote-table th { background: #4f6367; color: #fff; padding: 10px 12px; font-size: 12px; font-weight: 700; text-align: left; text-transform: uppercase; letter-spacing: 0.3px; }
                              .quote-table th:last-child { text-align: right; }
                              .quote-table td { padding: 10px 12px; font-size: 13px; border-bottom: 1px solid #e8e8e8; vertical-align: top; }
                              .quote-table td:last-child { text-align: right; font-weight: 600; white-space: nowrap; }
                              .quote-table td a { color: #F5861F; text-decoration: underline; }
                              .vehicle-cell { display: flex; flex-direction: column; gap: 2px; }
                              .vehicle-cell .veh-name { font-weight: 700; font-size: 13px; }
                              .vehicle-cell .veh-meta { font-size: 12px; color: #666; }

                              /* Totals */
                              .totals { width: 100%; border-collapse: collapse; margin-bottom: 0; }
                              .totals td { padding: 8px 12px; font-size: 13px; }
                              .totals .label-cell { text-align: left; }
                              .totals .spacer { width: 50%; }
                              .totals .desc-cell { text-align: right; font-weight: 600; color: #555; }
                              .totals .val-cell { text-align: right; font-weight: 600; white-space: nowrap; }
                              .total-row { background: #4f6367; }
                              .total-row td { padding: 14px 12px; font-size: 16px; font-weight: 700; }
                              .total-row .total-label { color: #F5861F; text-transform: uppercase; letter-spacing: 1px; text-align: center; }
                              .total-row .total-val { color: #fff; text-align: right; }

                              /* Validity */
                              .validity { margin-top: 32px; padding-top: 20px; border-top: 1px solid #ddd; }
                              .validity h3 { font-size: 15px; font-weight: 700; margin-bottom: 8px; }
                              .validity p { font-size: 13px; color: #555; line-height: 1.6; }
                              .validity .accept-note { font-style: italic; color: #F5861F; font-size: 12px; margin-top: 4px; }

                              /* Footer */
                              .doc-footer { margin-top: 28px; font-size: 12px; color: #888; display: flex; justify-content: space-between; align-items: flex-end; }
                              .doc-footer a { color: #F5861F; text-decoration: none; }

                              @media print { body { padding: 24px; } }
                            </style>
                          </head>
                          <body>
                            <div class="page">
                              <div class="doc-header">
                                <h1>QikTruck Logistics</h1>
                                <img class="logo" src="https://media.qiktruck.co.za/dark-green-qiktruck-logo.png" alt="QikTruck" />
                              </div>

                              <div class="doc-title">Quotation</div>
                              <div class="company-info">
                                472 Spionkop Ave, Kya Sand, Johannesburg, 2163<br/>
                                VAT: 4700316260<br/>
                                +27 66 378 4460 &nbsp;&nbsp; support@qiktruck.co.za
                              </div>

                              <div class="bill-row">
                                <div class="bill-to">
                                  <h3>Bill To:</h3>
                                  ${(email || prospectemail) ? '<p>' + (email || prospectemail) + '</p>' : ''}
                                  ${(mobilenumber || prospectmobilenumber) ? '<p>' + (mobilenumber || prospectmobilenumber) + '</p>' : ''}
                                </div>
                                <div class="quote-meta">
                                  ${fullQuote.storedQuoteId ? '<div><strong>Quote #:</strong> ' + fullQuote.storedQuoteId.split('-')[0] + '</div>' : ''}
                                  <div><strong>Quote Date:</strong> ${fmt(quoteDate)}</div>
                                </div>
                              </div>

                              <table class="quote-table">
                                <thead>
                                  <tr>
                                    <th>Vehicle type</th>
                                    <th>Order Description</th>
                                    <th>Collection</th>
                                    <th>Delivery</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <div class="vehicle-cell">
                                        <span class="veh-name">${vehLabel}</span>
                                      </div>
                                    </td>
                                    <td>${description || "—"}<br/><span style="font-size:12px;color:#666;">${runners > 0 ? runners + ' helper' + (runners > 1 ? 's' : '') : '0 helpers'}<br/>${floors > 0 ? floors + ' floor' + (floors > 1 ? 's' : '') : '0 floors'}</span></td>
                                    <td><a href="#">${collectionAddress || "—"}</a></td>
                                    <td><a href="#">${deliveryAddress || "—"}</a></td>
                                    <td>${fmtR(tripCost)}</td>
                                  </tr>
                                </tbody>
                              </table>

                              <table class="totals">
                                <tr>
                                  <td class="spacer"></td>
                                  <td class="label-cell">Service fee</td>
                                  <td class="desc-cell">Logistics Administration</td>
                                  <td class="val-cell">${fmtR(serviceFee)}</td>
                                </tr>
                                <tr>
                                  <td class="spacer"></td>
                                  <td class="label-cell">VAT @ 15%</td>
                                  <td class="desc-cell"></td>
                                  <td class="val-cell">${fmtR(vatAmount)}</td>
                                </tr>
                                <tr class="total-row">
                                  <td colspan="2"></td>
                                  <td class="total-label">TOTAL PAYABLE</td>
                                  <td class="total-val">${fmtR(totalRands)}</td>
                                </tr>
                              </table>

                              <div class="validity">
                                <h3>QUOTATION VALIDITY</h3>
                                <p>This quotation is valid until <strong>${fmt(validUntil)}</strong> (7 days from issue).</p>
                                <p class="accept-note">To accept this quotation, please confirm your booking via the QikTruck app or contact us.</p>
                              </div>

                              <div class="doc-footer">
                                <div><em>* Terms and conditions > <a href="https://qiktruck.co.za/terms">https://qiktruck.co.za/terms</a></em></div>
                                <div>Generated on: ${quoteDate.toLocaleString("en-ZA", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })} SAST</div>
                              </div>
                            </div>
                          </body>
                        </html>
                      `);
                      printWindow.document.close();
                      setTimeout(() => { printWindow.print(); }, 500);
                    }}
                  >
                    <i className="mdi mdi-file-pdf-box"></i>
                    Download PDF
                  </button>
                </div>
              </div>

              {/* Other Vehicle Options */}
              {fullQuote.otherOptions?.filter(o => o.sellingPrice > 0)?.length > 0 && (
                <div className="l3-other-options">
                  <h4>Other vehicle options</h4>
                  <div className="l3-other-options-scroll" ref={otherOptionsRef}>
                    {fullQuote.otherOptions.filter(o => o.sellingPrice > 0).map((option, idx) => (
                      <div
                        key={idx}
                        className={`l3-other-option-card ${truckType === option.truckType ? "active" : ""}`}
                        onClick={() => {
                          setTruckType(option.truckType);
                          setTimeout(() => getQuote(), 100);
                        }}
                      >
                        <img src={getImage(option.truckType)} alt={option.truckType} />
                        <span className="l3-other-option-name">
                          {option.truckType?.replace("open", "").replace("closed", "")}
                        </span>
                        <span className="l3-other-option-price">
                          <CurrencyFormat
                            value={option.sellingPrice / 100}
                            displayType="text"
                            thousandSeparator={true}
                            prefix="R"
                            decimalScale={0}
                          />
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        )}

        {/* Booking Form (shows after accepting quote) */}
        {fullQuote.sellingPrice > 0 && acceptedOffer && (
          <section className="l3-booking-section" id="makebooking">
            <div className="l3-section-container">
              <div className="l3-section-header">
                <span className="l3-section-badge">Step 3</span>
                <h2 className="l3-section-title">
                  Complete Your Booking
                  <span className="l3-booking-price">
                    {" "}at{" "}
                    <CurrencyFormat
                      value={fullQuote[acceptedOffer] / 100}
                      displayType="text"
                      thousandSeparator={true}
                      prefix="R"
                      decimalScale={2}
                    />
                  </span>
                </h2>
              </div>

              <div className="l3-booking-form">
                <div className="l3-booking-form-grid">
                  <div className="l3-form-group">
                    <label className="l3-form-label">First Name *</label>
                    <input
                      type="text"
                      className="l3-form-input"
                      value={firstname}
                      onChange={(e) => setFirstname(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group">
                    <label className="l3-form-label">Surname *</label>
                    <input
                      type="text"
                      className="l3-form-input"
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group">
                    <label className="l3-form-label">Email *</label>
                    <input
                      type="email"
                      className="l3-form-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group">
                    <label className="l3-form-label">Mobile Number *</label>
                    <input
                      type="tel"
                      className="l3-form-input"
                      value={mobilenumber}
                      onChange={(e) => setMobilenumber(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group">
                    <label className="l3-form-label">Collection Date *</label>
                    <input
                      type="date"
                      className="l3-form-input"
                      value={collectiondate}
                      min={new Date().toISOString().split("T")[0]}
                      onChange={(e) => setCollectiondate(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group">
                    <label className="l3-form-label">Collection Time *</label>
                    <input
                      type="time"
                      className="l3-form-input"
                      value={collectiontime}
                      onChange={(e) => setCollectiontime(e.target.value)}
                    />
                  </div>

                  <div className="l3-form-group full-width">
                    <label className="l3-form-label">Description of Goods *</label>
                    <textarea
                      className="l3-form-input l3-textarea"
                      value={description}
                      placeholder="Please describe what we're moving in detail..."
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>

                  {/* Terms and Conditions Card */}
                  <div className="l3-form-group full-width">
                    <div 
                      className={`l3-terms-card ${agreeToTerms ? 'l3-terms-agreed' : ''}`}
                      onClick={() => setAgreeToTerms(!agreeToTerms)}
                    >
                      <div className="l3-terms-checkbox">
                        {agreeToTerms && <i className="mdi mdi-check"></i>}
                      </div>
                      <div className="l3-terms-content">
                        <div className="l3-terms-title">
                          I accept the Terms and Conditions
                        </div>
                        <div className="l3-terms-subtitle">
                          I agree to the{" "}
                          <a 
                            href="/terms" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                          >
                            Terms and Conditions
                          </a>
                          {" "}and the limits of liability.
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        checked={agreeToTerms}
                        onChange={() => {}}
                        style={{ display: 'none' }}
                      />
                    </div>
                    
                    {!agreeToTerms && (
                      <p className="l3-terms-warning">
                        <i className="mdi mdi-information-outline"></i>
                        Please accept the Terms and Conditions to continue
                      </p>
                    )}
                  </div>
                </div>

                <button
                  className="l3-btn l3-btn-primary l3-btn-book"
                  onClick={acceptQuote}
                  disabled={!validStepTwo() || !agreeToTerms || loading}
                >
                  {loading ? (
                    <>
                      <span className="l3-spinner"></span>
                      Processing...
                    </>
                  ) : (
                    <>
                      <i className="mdi mdi-check-circle"></i>
                      Confirm Booking
                    </>
                  )}
                </button>

                {!loading && apierror && (
                  <div className="l3-error-message">
                    <i className="mdi mdi-alert-circle"></i>
                    {apierror}
                  </div>
                )}
              </div>
            </div>
          </section>
        )}

        {/* Services Section */}
        <section className="l3-services" id="services">
          <div className="l3-section-container">
            <div className="l3-section-header">
              <span className="l3-section-badge">Our Services</span>
              <h2 className="l3-section-title">What We Can Move For You</h2>
              <p className="l3-section-subtitle">
                From small parcels to large furniture - we've got you covered
              </p>
            </div>
            
            <div className="l3-services-grid">
              <div className="l3-service-card">
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/goods-transportation-delivery.png" alt="Goods Transportation" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Goods Transportation</h3>
                  <p className="l3-service-desc">
                    Deliver goods to your customers, warehouse, shop, or home. Perfect for manufacturers, retailers, and supply shops.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Once-off deliveries</li>
                    <li><i className="mdi mdi-check-circle"></i>Short & long term contracts</li>
                    <li><i className="mdi mdi-check-circle"></i>Business-to-business logistics</li>
                  </ul>
                  <a href="/truck-hire?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="l3-service-card featured">
                <div className="l3-service-badge">Most Popular</div>
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/furniture-delivery-service.png" alt="Furniture Delivery" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Furniture Delivery</h3>
                  <p className="l3-service-desc">
                    Home and office moves on demand. We handle furniture, appliances, and personal goods with care.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Professional handlers</li>
                    <li><i className="mdi mdi-check-circle"></i>Careful loading & unloading</li>
                    <li><i className="mdi mdi-check-circle"></i>Same-day service available</li>
                  </ul>
                  <a href="/furniture-delivery-services?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="l3-service-card">
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/home-office-moving.png" alt="Home & Office Moves" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Home & Office Moves</h3>
                  <p className="l3-service-desc">
                    Full relocation services for residential and commercial spaces. We make moving day stress-free.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Packing assistance available</li>
                    <li><i className="mdi mdi-check-circle"></i>Multiple trips if needed</li>
                    <li><i className="mdi mdi-check-circle"></i>Insured transport</li>
                  </ul>
                  <a href="/furniture-delivery-services?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="l3-service-card">
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/scheduled-delivery-trips.png" alt="Scheduled Trips" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Scheduled Trips</h3>
                  <p className="l3-service-desc">
                    Plan ahead with scheduled transportation. Trained drivers for long and short distance trips.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Advance booking</li>
                    <li><i className="mdi mdi-check-circle"></i>Reliable timing</li>
                    <li><i className="mdi mdi-check-circle"></i>24/7 availability</li>
                  </ul>
                  <a href="/truck-hire?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="l3-service-card">
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/construction-materials-delivery.png" alt="Construction Materials" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Construction Materials</h3>
                  <p className="l3-service-desc">
                    Transport building materials, equipment, and supplies to construction sites safely and on time.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Heavy load capable</li>
                    <li><i className="mdi mdi-check-circle"></i>Site-to-site delivery</li>
                    <li><i className="mdi mdi-check-circle"></i>Bulk material transport</li>
                  </ul>
                  <a href="/bakkie-hire?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>

              <div className="l3-service-card">
                <div className="l3-service-image">
                  <img src="https://media.qiktruck.co.za/courier-parcel-delivery.png" alt="Courier & Parcels" />
                </div>
                <div className="l3-service-content">
                  <h3 className="l3-service-title">Courier & Parcels</h3>
                  <p className="l3-service-desc">
                    Quick delivery for packages, documents, and smaller items across town or between cities.
                  </p>
                  <ul className="l3-service-list">
                    <li><i className="mdi mdi-check-circle"></i>Express delivery</li>
                    <li><i className="mdi mdi-check-circle"></i>Real-time tracking</li>
                    <li><i className="mdi mdi-check-circle"></i>Proof of delivery</li>
                  </ul>
                  <a href="/truck-hire?src=landing3" className="l3-service-link">
                    Learn More <i className="mdi mdi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Customer Reviews Section */}
        <section className="l3-reviews" id="reviews">
          <div className="l3-section-container">
            <div className="l3-section-header">
              <span className="l3-section-badge">Customer Reviews</span>
              <h2 className="l3-section-title">What Our Customers Say</h2>
              <p className="l3-section-subtitle">
                Trusted by thousands of satisfied customers across South Africa
              </p>
            </div>

            <div className="l3-reviews-grid">
              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                </div>
                <p className="l3-review-text">
                  "Excellent service! The driver arrived on time and handled my furniture with great care. Will definitely use QikTruck again for my next move."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">TM</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">Thabo M.</span>
                    <span className="l3-review-location">Johannesburg</span>
                  </div>
                </div>
              </div>

              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                </div>
                <p className="l3-review-text">
                  "The quote was instant and the price was fair. No hidden charges at all. The tracking feature gave me peace of mind throughout the delivery."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">SP</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">Sarah P.</span>
                    <span className="l3-review-location">Cape Town</span>
                  </div>
                </div>
              </div>

              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star-half-full"></i>
                </div>
                <p className="l3-review-text">
                  "I use QikTruck for my small business deliveries. Reliable, professional, and my customers are always happy with the service."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">JN</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">James N.</span>
                    <span className="l3-review-location">Durban</span>
                  </div>
                </div>
              </div>

              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                </div>
                <p className="l3-review-text">
                  "Moved my entire 3-bedroom house in one day! The helpers were strong and careful. Highly recommend for anyone planning a move."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">LK</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">Lindiwe K.</span>
                    <span className="l3-review-location">Pretoria</span>
                  </div>
                </div>
              </div>

              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                </div>
                <p className="l3-review-text">
                  "Best bakkie hire service in SA! Booked at 8am, delivery done by noon. The app makes everything so easy to track."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">MV</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">Mike V.</span>
                    <span className="l3-review-location">Port Elizabeth</span>
                  </div>
                </div>
              </div>

              <div className="l3-review-card">
                <div className="l3-review-stars">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                </div>
                <p className="l3-review-text">
                  "Used QikTruck to transport building materials to my site. Driver was professional and everything arrived in perfect condition."
                </p>
                <div className="l3-review-author">
                  <div className="l3-review-avatar">AN</div>
                  <div className="l3-review-info">
                    <span className="l3-review-name">Ahmed N.</span>
                    <span className="l3-review-location">Bloemfontein</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="l3-reviews-summary">
              <div className="l3-reviews-rating">
                <span className="l3-reviews-score">4.8</span>
                <div className="l3-reviews-stars-large">
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star"></i>
                  <i className="mdi mdi-star-half-full"></i>
                </div>
                <span className="l3-reviews-count">Based on  10,000++ reviews</span>
              </div>
            </div>
          </div>
        </section>

        {/* Coverage Map Section */}
        <section className="l3-coverage-section">
          <div className="l3-section-container">
            <div className="l3-section-header">
              <span className="l3-section-badge">Nationwide</span>
              <h2 className="l3-section-title">We Cover All of South Africa</h2>
              <p className="l3-section-subtitle">
                With drivers in every major city and town, QikTruck delivers anywhere in South Africa
              </p>
            </div>
            
            <div className="l3-map-container">
              <svg viewBox="0 0 500 450" className="l3-sa-map">
                {/* South Africa outline - simplified */}
                <path 
                  className="l3-map-outline"
                  d="M180 50 L280 45 L350 60 L420 90 L460 140 L480 200 L475 260 L450 310 L400 360 L340 390 L280 400 L220 395 L160 370 L100 320 L60 260 L50 200 L55 140 L80 90 L130 60 Z"
                  fill="#e8f5f3"
                  stroke="#34d1bf"
                  strokeWidth="2"
                />
                
                {/* Major cities with dots */}
                {/* Johannesburg */}
                <circle cx="320" cy="180" r="12" className="l3-map-dot l3-map-dot-large" />
                <text x="320" y="205" className="l3-map-label">Johannesburg</text>
                
                {/* Pretoria */}
                <circle cx="330" cy="155" r="8" className="l3-map-dot" />
                <text x="345" y="160" className="l3-map-label-small">Pretoria</text>
                
                {/* Cape Town */}
                <circle cx="120" cy="350" r="12" className="l3-map-dot l3-map-dot-large" />
                <text x="120" y="375" className="l3-map-label">Cape Town</text>
                
                {/* Durban */}
                <circle cx="400" cy="280" r="10" className="l3-map-dot" />
                <text x="415" y="285" className="l3-map-label">Durban</text>
                
                {/* Port Elizabeth / Gqeberha */}
                <circle cx="280" cy="360" r="8" className="l3-map-dot" />
                <text x="280" y="385" className="l3-map-label-small">Gqeberha</text>
                
                {/* Bloemfontein */}
                <circle cx="260" cy="250" r="7" className="l3-map-dot" />
                <text x="275" y="255" className="l3-map-label-small">Bloemfontein</text>
                
                {/* East London */}
                <circle cx="340" cy="340" r="6" className="l3-map-dot" />
                <text x="355" y="345" className="l3-map-label-small">East London</text>
                
                {/* Polokwane */}
                <circle cx="350" cy="115" r="6" className="l3-map-dot" />
                <text x="365" y="120" className="l3-map-label-small">Polokwane</text>
                
                {/* Nelspruit */}
                <circle cx="395" cy="170" r="6" className="l3-map-dot" />
                <text x="410" y="175" className="l3-map-label-small">Nelspruit</text>
                
                {/* Kimberley */}
                <circle cx="200" cy="250" r="5" className="l3-map-dot" />
                <text x="165" y="255" className="l3-map-label-small">Kimberley</text>
                
                {/* Pietermaritzburg */}
                <circle cx="380" cy="295" r="5" className="l3-map-dot" />
                
                {/* Richards Bay */}
                <circle cx="420" cy="250" r="5" className="l3-map-dot" />
                
                {/* George */}
                <circle cx="180" cy="365" r="5" className="l3-map-dot" />
                
                {/* Stellenbosch */}
                <circle cx="130" cy="360" r="4" className="l3-map-dot" />
                
                {/* Rustenburg */}
                <circle cx="290" cy="165" r="5" className="l3-map-dot" />
                
                {/* Upington */}
                <circle cx="140" cy="220" r="4" className="l3-map-dot" />
              </svg>
              
              <div className="l3-map-stats">
                <div className="l3-map-stat">
                  <span className="l3-map-stat-number">15,000+</span>
                  <span className="l3-map-stat-label">Verified Drivers</span>
                </div>
                <div className="l3-map-stat">
                  <span className="l3-map-stat-number">50+</span>
                  <span className="l3-map-stat-label">Cities Covered</span>
                </div>
                <div className="l3-map-stat">
                  <span className="l3-map-stat-number">9</span>
                  <span className="l3-map-stat-label">Provinces</span>
                </div>
              </div>
            </div>
            
            <div className="l3-coverage-cities">
              <p className="l3-coverage-text">
                <strong>Major metros:</strong> Johannesburg, Cape Town, Durban, Pretoria, Port Elizabeth, Bloemfontein
              </p>
              <p className="l3-coverage-text">
                <strong>And expanding to:</strong> Polokwane, Nelspruit, East London, Kimberley, Rustenburg, George, and more!
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="l3-cta">
          <div className="l3-cta-content">
            <h2 className="l3-cta-title">Ready to Move?</h2>
            <p className="l3-cta-subtitle">
              Join thousands of satisfied customers who trust QikTruck
            </p>
            <div className="l3-cta-buttons">
              <a href="#vehiclelist" className="l3-btn l3-btn-primary">
                Get Your Free Quote
                <i className="mdi mdi-arrow-right"></i>
              </a>
            </div>
            <button 
              className="l3-reset-data-link"
              onClick={resetSavedData}
            >
              <i className="mdi mdi-refresh"></i> Clear saved form data
            </button>
          </div>
        </section>
      </main>

      <Footer />

      {/* Driver/Customer Prompt Modal */}
      {showUserTypePrompt && (
        <div className="l3-modal-overlay">
          <div className="l3-modal">
            <div className="l3-modal-icon">
              <i className="mdi mdi-account-question"></i>
            </div>
            <h3 className="l3-modal-title">Quick Question</h3>
            <p className="l3-modal-text">
              Before we get your quote, please confirm:
            </p>
            <div className="l3-modal-options">
              <button 
                className="l3-modal-btn l3-modal-btn-primary"
                onClick={confirmCustomerAndGetQuote}
              >
                <i className="mdi mdi-package-variant"></i>
                <span>I need to move goods</span>
                <small>Get an instant delivery quote</small>
              </button>
              <a 
                href="/partner-drivers"
                className="l3-modal-btn l3-modal-btn-secondary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="mdi mdi-truck"></i>
                <span>I'm a driver wanting to register</span>
                <small>Go to driver registration portal</small>
              </a>
            </div>
            <button 
              className="l3-modal-close"
              onClick={() => setShowUserTypePrompt(false)}
            >
              <i className="mdi mdi-close"></i>
            </button>
          </div>
        </div>
      )}

      {/* Reset Confirmation Modal */}
      {showResetConfirm && (
        <div className="l3-modal-overlay">
          <div className="l3-modal l3-modal-sm">
            <div className="l3-modal-icon l3-modal-icon-warning">
              <i className="mdi mdi-alert-outline"></i>
            </div>
            <h3 className="l3-modal-title">Clear Saved Data?</h3>
            <p className="l3-modal-text">
              This will reset all your saved form information including addresses, contact details, and preferences.
            </p>
            <div className="l3-modal-actions">
              <button 
                className="l3-btn l3-btn-outline"
                onClick={() => setShowResetConfirm(false)}
              >
                Cancel
              </button>
              <button 
                className="l3-btn l3-btn-danger"
                onClick={confirmResetData}
              >
                Yes, Clear Data
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reset Success Toast */}
      {showResetSuccess && (
        <div className="l3-toast l3-toast-success">
          <i className="mdi mdi-check-circle"></i>
          <span>All saved data has been cleared</span>
        </div>
      )}
    </React.Fragment>
  );
};

export default Landing3;
